import { Form } from 'antd';
import styled from 'styled-components';

export const StyledFormItem = styled(Form.Item)`
  width: 100%;
  .ant-form-item-extra {
    min-height: unset;
  }
`;
